export const SCORE_MAX = 200

class Game {

  constructor(name, players, rounds, scores, winnerID = -1) {
    this.name = name                /* {string} */
    this.players = players || []    /* [{player}] */
    this.rounds = rounds || []      /* [[playerRound]] */
    this.scores = scores || []      /* [playerScore] */
    this.winnerID = winnerID        /* {number} */
    this.yanivID = null             /* {number} */
  }

  addRound(round) {
    let score,
        gameOver,
        hasCounter = this.roundHasCounter(round, this.yanivID),
        num = this.rounds.length

    const applyDouche = () => {
      if (score.total % 50 === 0) {
        score.douche = true
        score.total -= 50
      }
    }

    this.scores[num] = []
    this.initScores()

    round.forEach((points, index) => {
      score = this.scores[num][index]
      if (index === this.yanivID) {
        score.yaniv = true
        if (hasCounter) {
          score.contre = true
          score.total += points + 30
          if (points > 0) applyDouche()
        }
      } else {
        score.total += points
        if (points > 0) applyDouche()
      }

      if (score.total >= SCORE_MAX) gameOver = true
    })

    this.rounds.push(round)
    if (gameOver) {
      let minusScore = SCORE_MAX
      this.scores[num].forEach((score, index) => {
        if (score.total < minusScore) {
          minusScore = score.total
          this.winnerID = index
        }
      })
    }
  }

  /**
   * Return true if at least one player has a lower score than the player who had yaniv
   */
  roundHasCounter(round, playerIDYaniv) {
    let yanivScore = round[playerIDYaniv],
        otherScores = [...round.slice(0, playerIDYaniv), ...round.slice(playerIDYaniv+1)]
    return Math.min(...otherScores) <= yanivScore;
  }

  removeLastRound() {
    this.rounds = this.rounds.slice(0, -1)
    this.scores = this.scores.slice(0, -1)
    this.winnerID = -1
  }

  setPlayers(players) {
    this.players = players
  }

  setYanivID(index) {
    this.yanivID = index
  }

  initScores() {
    let score = this.scores[this.scores.length-1],
        previous = this.scores.length ? this.scores[this.scores.length-2] : null
    this.players.map((player, id) => {
      score.push({
        'total': previous ? previous[id].total : 0,
        'douche': false,
        'contre': false,
        'yaniv': false,
      })
    })
  }

  hasPlayers() {
    return this.players && this.players.length
  }
}

class GamesStore {
  constructor() {
    this.state = {
      games: this.getLocalStorage(),
      currentGame: null,
    }
  }

  addGame(name) {
    let gameID = this.state.games.length,
        game = new Game(name)
    this.state.games.push(game)
    return gameID
  }

  removeGame(gameID) {
    this.state.games.splice(gameID, 1)
  }

  getGame(gameID) {
    return this.state.games[gameID]
  }

  setCurrentGame(gameID) {
    this.state.currentGame = this.state.games[gameID]
  }

  getLocalStorage() {
    let storedGames = window.localStorage['yaniv-score-games'],
      gamesData = storedGames ? JSON.parse(storedGames) : [],
      games = []
    gamesData.map(data => {
      games.push(new Game(data.name, data.players, data.rounds, data.scores, data.winnerID))
    })
    return games
  }

  pushLocalStorage() {
    window.localStorage.setItem('yaniv-score-games', JSON.stringify(this.state.games))
  }
}

export default new GamesStore()



// WEBPACK FOOTER //
// ./src/store/GamesStore.js